import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Col, message, Row, Spin } from 'antd';
import MessageConfirmModal from '../messageModal/MessageConfirmModal';
import InputComponent from '../input/InputComponent';
import {useNavigate, useParams } from 'react-router-dom';
import { BANNER_URL, PRODUCT_CATEGORY_URL, PRODUCT_URL } from '../../api/URLs';
import { getDataRequest, postDataRequest, putDataRequest } from '../../api/serviceMethods';
import SelectComponent from '../select/SelectComponent';
import DragUploadComponent from '../upload/DragUploadComponent';
import TextAreaComponent from '../input/TextAreaComponent';
import HeaderCreateStaffComponent from '../header/HeaderCreateStaffComponent';
import OSSUploadWrapper from '../upload/OSSUploadWrapper';

function NewBanner() {
    const { newStep } = useParams();
    const { t } = useTranslation();
    const { id } = useParams(); 
    const messageModalRef = useRef("");
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false)
    const [category, setCategory] = useState([])
    const [dataObject, setDataObject] = useState({
        images: [{ // multiple images
            url: "",
            size: "",
            name: ""
        }],
        category: "", // product category _id
        status: true 
    });
    const [picUrl, setpicUrl] = useState([])

    const fetchCategory = async () => {
        const datas = [
            { label: "技术与教育", value: "技术与教育" },
            { label: "产品", value: "产品" },
        ];

        setCategory(datas);
    };
    useEffect(() => {
        fetchCategory()
    }, [])

    const addNewValue = async (data) => {
        setDataObject(
            {
                ...data,
                category: data?.category ? data?.category : "", // product category _id
                status: data.status || ""
            }
        )
        setpicUrl(data.images ?
            [
                {
                    name: data.images && data.images[0].name || "",
                    size: data.images && data.images[0].size || "",
                    url: data.images && data.images[0].url || "",
                }
            ]
            : [])
    }

    const getDetailById = async () => {
        try {
            setLoading(true);
            await getDataRequest(`${BANNER_URL}/${id && id}`)
                .then((res) => {
                    if (res.status === 200) {
                        addNewValue(res.data)
                    } 
                    setLoading(false);
                })
                .catch((err) => {
                    console.log(err);
                    setLoading(false);
                });
        } catch (error) {
            setLoading(false);
            message.error('Server Error!');
        }
    }
    useEffect(() => {
        if (id && id) { getDetailById() }
    }, [newStep]);

    const checkError = () => {
        if (
            picUrl && picUrl.length === 0 ||
            !dataObject.category
        ) {
            return true
        }
        return false
    }
    const insertParams = () => {
        const productPayload = {
            images: picUrl && picUrl.length > 0 ? picUrl[0].url : "",
            images: picUrl && picUrl.length > 0 ? [{
                url: picUrl && picUrl.length > 0 ? picUrl[0].url : "",
                size: picUrl && picUrl.length > 0 ? picUrl[0].size : "",
                name: picUrl && picUrl.length > 0 ? picUrl[0].name : "",
            }] : "",
            category: dataObject.category, // product category _id
            status: dataObject.status
        }
        return productPayload
    }

    const hadleUpdateProduct = async (e) => {
        e.preventDefault();
        setIsSubmit(true);
        try {
            const productPayload = insertParams()
            if (checkError()) {
                return false;
            }
            setLoading(true);
            await putDataRequest(`${BANNER_URL}/${id && id} `, productPayload)
                .then((res) => {
                    if (res.status === 200) {
                        setLoading(false);
                        messageModalRef.current.showSuccessConfirmsAutoClose(t(res && res.message), () => { }, "", true);
                        setTimeout(() => {
                            navigate("/banner")
                        }, 2000);
                    } else {
                        messageModalRef.current.showWarningConfirmsAutoClose(res && res.message, () => { }, "", true);
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    setLoading(false);
                    messageModalRef.current.showWarningConfirmsAutoClose(err && err.response && err.response.data && err.response.data.message || "Server Error!", () => { }, "", true);
                });
        } catch (error) {
            console.log("error", error)
            setLoading(false);
            message.error('Server Error!');
        }
    }

    // Save member
    const handleSubmit = async () => {
        setIsSubmit(true)
        if (checkError()) {
            return false
        }
        setLoading(true);
        const productPayload = insertParams()
        try {
            const res = await postDataRequest(BANNER_URL, productPayload);
            if (res?.status === 200) {
                messageModalRef.current.showSuccessConfirmsAutoClose(t(res && res.data?.message) || t("Saved Successfully"), () => { }, "", true);
                setTimeout(() => {
                    navigate("/banner")
                }, 2000);
            } else {
                messageModalRef.current.showWarningConfirmsAutoClose(res && res.data?.message || res.message || t("An error occurred."), () => { }, "", true);
            }
        } catch (err) {
            messageModalRef.current.showWarningConfirmsAutoClose(err && err.response && err.response.data && err.response.data.message || "Server Error!", () => { }, "", true);
        } finally {
            setLoading(false);
            setIsSubmit(false);
        }
    }

    return (
        <>
            <HeaderCreateStaffComponent
                bntTitle={<>
                    <Button
                        className='b-danger'
                        disabled={loading}
                        type="primary"
                        onClick={id ? hadleUpdateProduct : handleSubmit}
                        style={{
                            fontSize: '16px',
                            backgroundColor: "#E50A47",
                            border: "1px solid #e72158",
                            color: "#FFFFFF",
                            opacity: loading ? '0.4' : ""
                        }}
                        danger
                    >
                        {id ? t("Submit") : t(`Submit`)}
                    </Button>
                </>}
                isHide="view"
                onClick={() => {
                    navigate('/banner')
                }}
                backTitle={t('Create Banner')}
            >
                <Spin spinning={loading}>
                    {
                        !newStep || newStep - 0 === 1 ? <div className='container newDetail'>
                            <Row className='mb-5'>
                                <Col md={4}>{t("Image")} :</Col>
                                <Col md={20}>
                                    <Row className='w-100'>
                                        <Col md={24} sm={24}>
                                            <div className='w-100'>
                                                <OSSUploadWrapper
                                                    onUploadSuccess={(value) => {
                                                        setpicUrl([value]);
                                                    }}
                                                >
                                                    <DragUploadComponent
                                                        fileList={picUrl ? picUrl : []}
                                                        setFileList={(values) => {
                                                            setpicUrl(values)
                                                        }}
                                                    />
                                                </OSSUploadWrapper>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className='mt-4 d-flex align-items-center'>
                                <Col md={4}>{t("Type")} :</Col>
                                <Col md={20}>
                                    <SelectComponent
                                        options={category}
                                        value={dataObject.category}
                                        setValue={(value) => setDataObject((v) => ({ ...v, category: value }))}
                                        status={isSubmit && !dataObject.category && "error"}
                                        placeholder=""
                                    />

                                </Col>
                            </Row>
                        </div>
                            :
                            ""
                    }
                    <MessageConfirmModal textCentered ref={messageModalRef} />
                </Spin>
            </HeaderCreateStaffComponent>
        </>
    );
}

export default NewBanner;
